export default __webpack_public_path__ + "static/media/gas.0b32ff88.jpg";